export default class Screen {
    #name;
    el;
    #isActive;
    #hasStages;
    #currentStage = 1;
    #stagesNavButtons;
    #activeClassName = 'is-active';

    constructor(el) {
        this.el = el;
        this.#name = el.dataset.screen;
        this.#hasStages = this.el.classList.contains('js-screen-with-stages');
        this.#stagesNavButtons = Array.from(this.el.querySelectorAll('.js-screen-stage-nav-button'));

        if (this.#hasStages) {
            this.setActiveStage(1);
            this.initStagesNav();
        }
    }

    get name() {
        return this.#name;
    }

    setIsActive(isActive) {
        this.isActive = isActive;

        if (isActive) {
            this.el.classList.add(this.#activeClassName);
        } else {
            this.el.classList.remove(this.#activeClassName);
        }
    }

    setActiveStage(num) {
        this.#currentStage = num;
        this.el.dataset.screenStage = num;
    }

    initStagesNav() {
        this.#stagesNavButtons.forEach((button) => {
            button.addEventListener('click', () => {
                if (button.classList.contains('js-screen-stage-next')) {
                    this.setActiveStage(this.#currentStage + 1);
                }

                if (button.classList.contains('js-screen-stage-prev')) {
                    this.setActiveStage(this.#currentStage - 1);
                }
            });
        });
    }
}
